import { useWaitlistModal } from "../context/waitlist-modal-context";
import { useForm } from "../context/waitlist-context";

const LoanOption = ({ investmentData }: any) => {
  const { openWaitlistModal } = useWaitlistModal();
  const { updateFormData } = useForm();
  return (
    <div className="rounded-[12px] w-full bg-white p-6">
      <div className="flex items-center gap-2">
        <h1 className="text-[22px] font-bold">Loans</h1>
        <img
          src="/assets/money/investmentOptions.png"
          alt="investment options"
          className="w-fit h-[11.5px] object-cover"
        />
      </div>
      <div className="flex gap-4 flex-wrap justify-start mt-4">
        {investmentData.map((item: any, index: number) => (
          <div
            key={index}
            className="flex flex-col items-start p-4 border-[1px] rounded-[10px] w-[270px] h-[180px] shadow-[0_0_15px_0_rgba(0,0,0,0.1)] relative overflow-hidden"
          >
            <div className="flex items-center gap-4">
              <img
                src={item.image_url}
                alt={item.title}
                className="w-[40px] h-[40px] object-cover"
              />
              <div className="font-bold">
                <h1>{item.name}</h1>
              </div>
            </div>
            {item?.interest_rate && (
              <>
                <p className="text-sm text-gray-500 mt-[20px]">Interest rate</p>
                <p className="text-xl font-bold">
                  {item?.interest_rate || 0}%{" "}
                  <span className="text-sm font-normal text-gray-500">
                    p.a.
                  </span>
                </p>
              </>
            )}
            {item?.upto && (
              <>
                <p className="text-sm text-gray-500 mt-[20px]">Up to</p>
                <p className="text-xl font-bold">{item?.upto || "-"}</p>
              </>
            )}
            {item?.tag?.description && (
              <>
                <p className="text-sm text-gray-500 mb-1 mt-[20px]">
                  {item?.tag?.description}
                </p>
              </>
            )}
            <button
              className="bg-[#007aff] py-[4px] px-[15px] rounded-full leading-[1.33] text-white text-[15px] leading-[20px] mt-2"
              onClick={() => {
                updateFormData("form", {
                  type: item.redirect_url,
                });
                openWaitlistModal();
              }}
            >
              Apply Now
            </button>
            <img
              src="/assets/money/topology-design.webp"
              alt="design"
              className="absolute top-12 left-[120px]"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoanOption;
